export default "__VITE_ASSET__BHApgGFq__"